// origen: D=Doméstico, T=Transnacional, G=Gobierno, P=Política
const PRENSA_DATA = {
  'la-prensa': {
    canal: 'LA PRENSA',
    total: 5221044,
    totalSpots: 485731,
    data: [
      { pos: 1,  anunciante: 'BAC CREDOMATIC', inv: 372681, spots: 25058, origen: 'T' },
      { pos: 2,  anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 347001, spots: 26728, origen: 'D' },
      { pos: 3,  anunciante: 'BANCO DE OCCIDENTE', inv: 214412, spots: 22018, origen: 'D' },
      { pos: 4,  anunciante: 'ELEMENTS', inv: 184643, spots: 11124, origen: 'D' },
      { pos: 5,  anunciante: 'ASHLEY FURNITURE STORE', inv: 162182, spots: 10764, origen: 'T' },
      { pos: 6,  anunciante: 'DAVIVIENDA', inv: 160343, spots: 17022, origen: 'T' },
      { pos: 7,  anunciante: 'BANCO ATLANTIDA', inv: 155630, spots: 15192, origen: 'D' },
      { pos: 8,  anunciante: 'INSTITUTO DE LA PROPIEDAD', inv: 145912, spots: 19506, origen: 'G' },
      { pos: 9,  anunciante: 'BANCO LAFISE', inv: 133900, spots: 13998, origen: 'T' },
      { pos: 10, anunciante: 'PODER JUDICIAL', inv: 123568, spots: 16628, origen: 'G' },
      { pos: 11, anunciante: 'DERCHIE', inv: 121880, spots: 8225, origen: 'D' },
      { pos: 12, anunciante: 'DISTRIBUIDORA INDUSTRIAL SA DE CV', inv: 116574, spots: 7584, origen: 'D' },
      { pos: 13, anunciante: 'GRUPO OPSA', inv: 114654, spots: 6662, origen: 'D' },
      { pos: 14, anunciante: 'CASA JAAR.', inv: 112506, spots: 6626, origen: 'D' },
      { pos: 15, anunciante: 'BANPAIS', inv: 105689, spots: 13890, origen: 'D' },
      { pos: 16, anunciante: 'GRUPO EDITORIAL EYN', inv: 90082, spots: 5814, origen: 'T' },
      { pos: 17, anunciante: 'FERROMAX', inv: 77163, spots: 4860, origen: 'D' },
      { pos: 18, anunciante: 'SEL', inv: 75145, spots: 4374, origen: 'D' },
      { pos: 19, anunciante: 'HANKOOK', inv: 68225, spots: 3994, origen: 'D' },
      { pos: 20, anunciante: 'BANCO PROMERICA', inv: 64676, spots: 6462, origen: 'T' },
      { pos: 21, anunciante: 'BANRURAL', inv: 51992, spots: 6702, origen: 'T' },
      { pos: 22, anunciante: 'PAN AMERICAN LIFE INSURANCE COMPANY', inv: 48295, spots: 3348, origen: 'T' },
      { pos: 23, anunciante: 'ASSA COMPANIA DE SEGUROS', inv: 45579, spots: 3186, origen: 'D' },
      { pos: 24, anunciante: 'PLAZA LA NORTEÑA', inv: 44985, spots: 2916, origen: 'D' },
      { pos: 25, anunciante: 'GRUPO Q', inv: 44761, spots: 3276, origen: 'T' },
    ],
  },
  'la-tribuna': {
    canal: 'LA TRIBUNA',
    total: 4605405,
    totalSpots: 552736,
    data: [
      { pos: 1,  anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 502637, spots: 46740, origen: 'D' },
      { pos: 2,  anunciante: 'BANCO ATLANTIDA', inv: 400051, spots: 41626, origen: 'D' },
      { pos: 3,  anunciante: 'SERCOM DE HONDURAS', inv: 244428, spots: 16586, origen: 'T' },
      { pos: 4,  anunciante: 'BAC CREDOMATIC', inv: 238374, spots: 23460, origen: 'T' },
      { pos: 5,  anunciante: 'COHEP', inv: 166892, spots: 11728, origen: 'D' },
      { pos: 6,  anunciante: 'GRUPO CONTINENTAL', inv: 136133, spots: 12828, origen: 'D' },
      { pos: 7,  anunciante: 'DAVIVIENDA', inv: 123737, spots: 19322, origen: 'T' },
      { pos: 8,  anunciante: 'CORPORACION DINANT', inv: 119769, spots: 7930, origen: 'D' },
      { pos: 9,  anunciante: 'BANPAIS', inv: 83282, spots: 15620, origen: 'D' },
      { pos: 10, anunciante: 'GRUPO TERRA', inv: 82953, spots: 5714, origen: 'T' },
      { pos: 11, anunciante: 'FUNDACION HONDUREÑA DEL NIÑO CON CANCER', inv: 76829, spots: 5728, origen: 'D' },
      { pos: 12, anunciante: 'SECRETARIA DE INFRAESTRUCTURA Y TRANSPORTE', inv: 76473, spots: 14790, origen: 'D' },
      { pos: 13, anunciante: 'BANCO LAFISE', inv: 75055, spots: 12470, origen: 'T' },
      { pos: 14, anunciante: 'PODER JUDICIAL', inv: 71788, spots: 13874, origen: 'G' },
      { pos: 15, anunciante: 'SUPERMERCADOS LA COLONIA', inv: 63752, spots: 6200, origen: 'D' },
      { pos: 16, anunciante: 'INJUPEMP', inv: 61339, spots: 6592, origen: 'G' },
      { pos: 17, anunciante: 'FERROMAX', inv: 58789, spots: 5200, origen: 'D' },
      { pos: 18, anunciante: 'BANCO DE OCCIDENTE', inv: 58383, spots: 8686, origen: 'D' },
      { pos: 19, anunciante: 'INSTITUTO DE LA PROPIEDAD', inv: 51034, spots: 6056, origen: 'G' },
      { pos: 20, anunciante: 'FHIS', inv: 48752, spots: 8314, origen: 'D' },
      { pos: 21, anunciante: 'INSTITUTO DE PREVISION MILITAR IPM', inv: 48512, spots: 5228, origen: 'D' },
      { pos: 22, anunciante: 'ZAMORANO', inv: 47109, spots: 3726, origen: 'D' },
      { pos: 23, anunciante: 'MAPFRE HONDURAS', inv: 46392, spots: 4550, origen: 'T' },
      { pos: 24, anunciante: 'BANRURAL', inv: 44765, spots: 8212, origen: 'T' },
      { pos: 25, anunciante: 'LITHOPRESS', inv: 44759, spots: 3648, origen: 'D' },
    ],
  },
  'el-heraldo': {
    canal: 'EL HERALDO',
    total: 3945504,
    totalSpots: 481798,
    data: [
      { pos: 1,  anunciante: 'BAC CREDOMATIC', inv: 352716, spots: 30422, origen: 'T' },
      { pos: 2,  anunciante: 'BANCO ATLANTIDA', inv: 168884, spots: 23730, origen: 'D' },
      { pos: 3,  anunciante: 'INSTITUTO DE LA PROPIEDAD', inv: 162766, spots: 27194, origen: 'G' },
      { pos: 4,  anunciante: 'MANGO BIENES RAICES', inv: 155156, spots: 10952, origen: 'D' },
      { pos: 5,  anunciante: 'BANCO DE OCCIDENTE', inv: 151317, spots: 20562, origen: 'D' },
      { pos: 6,  anunciante: 'ELEMENTS', inv: 143844, spots: 11428, origen: 'D' },
      { pos: 7,  anunciante: 'DORMICENTRO', inv: 114557, spots: 9808, origen: 'D' },
      { pos: 8,  anunciante: 'BANCO LAFISE', inv: 114079, spots: 14796, origen: 'T' },
      { pos: 9,  anunciante: 'PODER JUDICIAL', inv: 99573, spots: 15879, origen: 'G' },
      { pos: 10, anunciante: 'BANPAIS', inv: 96958, spots: 16200, origen: 'D' },
      { pos: 11, anunciante: 'DERCHIE', inv: 96289, spots: 8280, origen: 'D' },
      { pos: 12, anunciante: 'DAVIVIENDA', inv: 96097, spots: 13682, origen: 'T' },
      { pos: 13, anunciante: 'GRUPO OPSA', inv: 82252, spots: 6438, origen: 'D' },
      { pos: 14, anunciante: 'GRUPO EDITORIAL EYN', inv: 62462, spots: 4966, origen: 'T' },
      { pos: 15, anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 59999, spots: 6858, origen: 'D' },
      { pos: 16, anunciante: 'BANCO PROMERICA', inv: 56789, spots: 6892, origen: 'T' },
      { pos: 17, anunciante: 'INSTITUTO DE PREVISION MILITAR IPM', inv: 48620, spots: 4702, origen: 'D' },
      { pos: 18, anunciante: 'BANRURAL', inv: 47013, spots: 7460, origen: 'T' },
      { pos: 19, anunciante: 'ENEE', inv: 45856, spots: 7020, origen: 'D' },
      { pos: 20, anunciante: 'FAMA MICROFINANCIERA HONDUREÑA', inv: 42332, spots: 3618, origen: 'D' },
      { pos: 21, anunciante: 'MAPFRE HONDURAS', inv: 40829, spots: 4156, origen: 'T' },
      { pos: 22, anunciante: 'PAN AMERICAN LIFE INSURANCE COMPANY', inv: 38695, spots: 3348, origen: 'T' },
      { pos: 23, anunciante: 'FINANCIERA MI CREDITO', inv: 37429, spots: 3348, origen: 'D' },
      { pos: 24, anunciante: 'BANHCAFE', inv: 36978, spots: 3252, origen: 'D' },
      { pos: 25, anunciante: 'HANKOOK', inv: 36231, spots: 2830, origen: 'D' },
    ],
  },
  'el-pais': {
    canal: 'EL PAIS',
    total: 2054840,
    totalSpots: 337956,
    data: [
      { pos: 1,  anunciante: 'BANCO ATLANTIDA', inv: 535276, spots: 71698, origen: 'D' },
      { pos: 2,  anunciante: 'DIDEMO', inv: 448866, spots: 36224, origen: 'D' },
      { pos: 3,  anunciante: 'BAC CREDOMATIC', inv: 154759, spots: 22560, origen: 'T' },
      { pos: 4,  anunciante: 'SEL', inv: 65567, spots: 9490, origen: 'D' },
      { pos: 5,  anunciante: 'BANPAIS', inv: 62301, spots: 17180, origen: 'D' },
      { pos: 6,  anunciante: 'DAVIVIENDA', inv: 57140, spots: 14190, origen: 'T' },
      { pos: 7,  anunciante: 'COHEP', inv: 49271, spots: 4528, origen: 'D' },
      { pos: 8,  anunciante: 'BANCO DE OCCIDENTE', inv: 46173, spots: 8514, origen: 'D' },
      { pos: 9,  anunciante: 'INPREMA', inv: 38067, spots: 9876, origen: 'D' },
      { pos: 10, anunciante: 'BANCO LAFISE', inv: 35655, spots: 10270, origen: 'T' },
      { pos: 11, anunciante: 'DIARIO LA TRIBUNA', inv: 34363, spots: 3336, origen: 'D' },
      { pos: 12, anunciante: 'AGUAS DE SAN PEDRO', inv: 29641, spots: 4516, origen: 'D' },
      { pos: 13, anunciante: 'BANRURAL', inv: 28418, spots: 7930, origen: 'T' },
      { pos: 14, anunciante: 'BANHCAFE', inv: 28224, spots: 3810, origen: 'D' },
      { pos: 15, anunciante: 'MAPFRE HONDURAS', inv: 26605, spots: 3770, origen: 'T' },
      { pos: 16, anunciante: 'IHSS', inv: 24375, spots: 7020, origen: 'D' },
      { pos: 17, anunciante: 'PAN AMERICAN LIFE INSURANCE COMPANY', inv: 22570, spots: 3250, origen: 'T' },
      { pos: 18, anunciante: 'BANCO PROMERICA', inv: 17997, spots: 4820, origen: 'T' },
      { pos: 19, anunciante: 'CNE CONSEJO NACIONAL ELECTORAL', inv: 17018, spots: 1560, origen: 'G' },
      { pos: 20, anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 15925, spots: 4456, origen: 'D' },
      { pos: 21, anunciante: 'PRESIDENCIA DE LA REPUBLICA', inv: 15017, spots: 3706, origen: 'G' },
      { pos: 22, anunciante: 'BANHPROVI', inv: 14445, spots: 4160, origen: 'D' },
      { pos: 23, anunciante: 'HASAN', inv: 13985, spots: 4030, origen: 'D' },
      { pos: 24, anunciante: 'SEGUROS CREFISA SA', inv: 13091, spots: 3640, origen: 'D' },
      { pos: 25, anunciante: 'BANCO POPULAR', inv: 12573, spots: 3640, origen: 'D' },
    ],
  },
  'cromos': {
    canal: 'CROMOS',
    total: 276251,
    totalSpots: 36118,
    data: [
      { pos: 1,  anunciante: 'EDITORIAL HABLEMOS CLARO', inv: 38528, spots: 4550, origen: 'D' },
      { pos: 2,  anunciante: 'COSPER', inv: 24713, spots: 3250, origen: 'D' },
      { pos: 3,  anunciante: 'PERFUMERIA MAGIE', inv: 19488, spots: 2600, origen: 'D' },
      { pos: 4,  anunciante: 'BAC CREDOMATIC', inv: 17419, spots: 2210, origen: 'T' },
      { pos: 5,  anunciante: 'BANCO DE OCCIDENTE', inv: 15662, spots: 2080, origen: 'D' },
      { pos: 6,  anunciante: 'BAYLORS ST LUKES MEDICAL CENTER', inv: 12603, spots: 1560, origen: 'D' },
      { pos: 7,  anunciante: 'CORTITELAS', inv: 11801, spots: 1560, origen: 'D' },
      { pos: 8,  anunciante: 'CHIMINIKE', inv: 9869, spots: 1300, origen: 'D' },
      { pos: 9,  anunciante: 'EXCEL AUTOMOTRIZ', inv: 8714, spots: 1170, origen: 'T' },
      { pos: 10, anunciante: 'BANPAIS', inv: 6966, spots: 910, origen: 'D' },
      { pos: 11, anunciante: 'CORPORACION LADY LEE', inv: 6760, spots: 910, origen: 'D' },
      { pos: 12, anunciante: 'CAROLINA HERRERA', inv: 6723, spots: 910, origen: 'D' },
      { pos: 13, anunciante: 'BANCO ATLANTIDA', inv: 5788, spots: 780, origen: 'D' },
      { pos: 14, anunciante: 'PACO RABANNE', inv: 5724, spots: 780, origen: 'D' },
      { pos: 15, anunciante: 'JEAN PAUL GAULTIER', inv: 4636, spots: 650, origen: 'D' },
      { pos: 16, anunciante: 'CORPORACION JAAR', inv: 3986, spots: 520, origen: 'D' },
      { pos: 17, anunciante: 'CAFE 1930', inv: 2981, spots: 390, origen: 'D' },
      { pos: 18, anunciante: 'QUEEN DI EVENTS', inv: 2974, spots: 390, origen: 'D' },
      { pos: 19, anunciante: 'CENTRO CITIZEN DE HONDURAS', inv: 2915, spots: 390, origen: 'D' },
      { pos: 20, anunciante: 'MAC COSMETICS', inv: 2837, spots: 390, origen: 'D' },
      { pos: 21, anunciante: 'CLINIQUE', inv: 2762, spots: 390, origen: 'D' },
      { pos: 22, anunciante: 'PUMA CENTROAMERICA', inv: 2001, spots: 260, origen: 'T' },
      { pos: 23, anunciante: 'DIAGNOS', inv: 1996, spots: 260, origen: 'D' },
      { pos: 24, anunciante: 'PLAZA VALENCIA', inv: 1993, spots: 260, origen: 'D' },
      { pos: 25, anunciante: 'INVERSIONES CORPORATIVAS DEL ATLANTICO', inv: 1990, spots: 260, origen: 'D' },
    ],
  },
  'revista-estilo': {
    canal: 'REVISTA ESTILO',
    total: 142935,
    totalSpots: 9710,
    data: [
      { pos: 1,  anunciante: 'PERFUMERIA MAGIE', inv: 40559, spots: 1728, origen: 'D' },
      { pos: 2,  anunciante: 'GRUPO Q', inv: 15952, spots: 670, origen: 'T' },
      { pos: 3,  anunciante: 'SUPERMERCADOS COLONIAL', inv: 14540, spots: 1080, origen: 'D' },
      { pos: 4,  anunciante: 'BAC CREDOMATIC', inv: 12910, spots: 864, origen: 'T' },
      { pos: 5,  anunciante: 'INVERNADEROS DEL TRIGO', inv: 8676, spots: 756, origen: 'D' },
      { pos: 6,  anunciante: 'GRUPO EDITORIAL EYN', inv: 7846, spots: 324, origen: 'T' },
      { pos: 7,  anunciante: 'GRUPO PLATINO', inv: 7782, spots: 454, origen: 'D' },
      { pos: 8,  anunciante: 'BANPAIS', inv: 5213, spots: 378, origen: 'D' },
      { pos: 9,  anunciante: 'SKECHERS', inv: 4636, spots: 216, origen: 'T' },
      { pos: 10, anunciante: 'DISTRIBUIDORA ISTMANIA', inv: 3463, spots: 216, origen: 'D' },
      { pos: 11, anunciante: 'WESTERN INTERNATIONAL SCHOOL', inv: 2956, spots: 324, origen: 'D' },
      { pos: 12, anunciante: 'BANCO LAFISE', inv: 2475, spots: 108, origen: 'T' },
      { pos: 13, anunciante: 'SYRE', inv: 2311, spots: 108, origen: 'D' },
      { pos: 14, anunciante: 'BANCO PROMERICA', inv: 2311, spots: 108, origen: 'T' },
      { pos: 15, anunciante: 'MACRIS SCHOOL', inv: 1970, spots: 216, origen: 'D' },
      { pos: 16, anunciante: 'THE MAYAN SCHOOL', inv: 1970, spots: 216, origen: 'D' },
      { pos: 17, anunciante: 'HUGO BOSS', inv: 1223, spots: 108, origen: 'D' },
      { pos: 18, anunciante: 'GRUPO MONARCA', inv: 1189, spots: 108, origen: 'D' },
      { pos: 19, anunciante: 'MARCAS MUNDIALES', inv: 1003, spots: 108, origen: 'D' },
      { pos: 20, anunciante: 'DAVIVIENDA', inv: 993, spots: 108, origen: 'T' },
      { pos: 21, anunciante: 'GRUPO OPSA', inv: 991, spots: 108, origen: 'D' },
      { pos: 22, anunciante: 'BAPTIST HEALTH INTERNATIONAL', inv: 982, spots: 108, origen: 'D' },
      { pos: 23, anunciante: 'DIAGNOS', inv: 982, spots: 108, origen: 'D' },
    ],
  },
};

export default PRENSA_DATA;
